(function(){
    'use strict';
    angular.module('Services').factory('ErrorReportingService', ErrorReportingService);
    ErrorReportingService.$inject = ['$http'];

    function ErrorReportingService($http) {
        return {
            sendError: (callback, error, data) => {
                $http({
                    url: ApiURLs.notification.sendError,
                    method: 'POST',
                    data: data,
                }).success((data) => {
                    callback(data);
                }).error((data) => {
                    error(data);
                });
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/ErrorReportingService.js